import {User} from "../../api";
import {Table,Row,Col} from "react-bootstrap";
import {BooleanConverter, MomentFormatter} from "../../components";

export type UserDisplayProps={
  user:User
}
const UserDisplay = ({ user }:UserDisplayProps) => {
  return (
    <Row>
    <Col xs={6}>
      <div className="pt-2">
        <h4 className="mb-3">Personal:</h4>
       <Table striped bordered hover>
  <tbody>
    <tr>
      <th><label>Email/Username</label></th>
        <td> {user.email} <span style={{display: "inline-table"}}>{BooleanConverter(user.is_active,"text-left text-start")}</span></td>
    </tr>
    <tr>
      <th><label>Role</label></th>
      <td>  <p>{user.role}</p></td>
    </tr>

    <tr>
      <th> <label>Name</label></th>
      <td> <p>
              {user.first_name} {user.last_name}
            </p></td>
    </tr>
   <tr>
      <th><label>Contact Number</label></th>
     <td> <p>{user.contact_number}</p></td>
    </tr>
   <tr>
      <th> <label>Address</label></th>
      <td> <p>{user.city}, {user.pin_code}</p></td>
    </tr>

   <tr>
      <th><label>Date Joined</label></th>
      <td><p>{MomentFormatter(user.date_joined)}</p></td>
    </tr>
    <tr>
      <th><label>Force Password Change</label></th>
      <td><p>{MomentFormatter(user.next_password_change_at)}</p></td>
    </tr>

  </tbody>
</Table>
      </div>

  </Col>

        <Col xs={6}>
      <div className="pt-2">
        <h4 className="mb-3">GSX:</h4>
       <Table striped bordered hover>
  <tbody>
    <tr>
      <th><label>Email/Username</label></th>
        <td> {user.gsx_user_name} <span style={{display: "inline-table"}}>{BooleanConverter(user.is_active,"text-left text-start")}</span></td>
    </tr>
    <tr>
      <th><label>Ship To</label></th>
      <td>  <p>{user.gsx_ship_to}</p></td>
    </tr>

    <tr>
      <th> <label>Technician ID</label></th>
      <td> <p>
              {user.gsx_technician_id}
            </p></td>
    </tr>
  <tr>
      <th> <label>Token</label></th>
      <td> <p>
              {user.gsx_auth_token}
            </p></td>
    </tr>
  <tr>
      <th> <label>Token Last refreshed On</label></th>
      <td> <p>
              {MomentFormatter(user.gsx_token_last_refreshed_on)}
            </p></td>
    </tr>



  </tbody>
</Table>
      </div>

  </Col>




    </Row>
  )
}

export default UserDisplay
